import React from "react";
import { plotTypes as plotTypesType } from "@/components/VivoPlots/types";
import BarIcon from "@/assets/icons/groupedBarplot.svg?react";
import BoxIcon from "@/assets/icons/box.svg?react";
import ScatterIcon from "@/assets/icons/scatter.svg?react";

export type UIPlotTypesType = {
  name: string;
  value: plotTypesType;
  icon: React.ReactNode;
};

const MetricCardIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="4"
      width="16"
      height="12"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.4"
    />
    <text
      x="10"
      y="10"
      fontSize="8"
      fontWeight="700"
      fill="currentColor"
      fontFamily="system-ui, sans-serif"
      textAnchor="middle"
      dominantBaseline="middle"
    >
      123
    </text>
  </svg>
);

const LineChartIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polyline
      points="2,14 6,9 10,11 14,5 18,7"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

const uiPlotTypes: UIPlotTypesType[] = [
  {
    name: "Bar",
    value: "barplot",
    icon: <BarIcon />,
  },
  {
    name: "Box",
    value: "swarm-box",
    icon: <BoxIcon />,
  },
  {
    name: "Scatter",
    value: "scatter",
    icon: <ScatterIcon />,
  },
  {
    name: "Metric",
    value: "metric-card",
    icon: <MetricCardIcon />,
  },
  {
    name: "Line",
    value: "line",
    icon: <LineChartIcon />,
  },
];

export const PlotTypeButtons = ({
  plotType,
  setPlotType,
}: {
  plotType: plotTypesType;
  setPlotType: (value: plotTypesType) => void;
}) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="grid grid-cols-5 gap-2">
        {uiPlotTypes.map((plot) => (
          <PlotTypeButton
            key={plot.value}
            plotType={plot}
            setPlotType={setPlotType}
            isSelected={plotType === plot.value}
          />
        ))}
      </div>
    </div>
  );
};

export const PlotTypeButton = ({
  plotType,
  setPlotType,
  isSelected,
}: {
  plotType: UIPlotTypesType;
  setPlotType: (value: plotTypesType) => void;
  isSelected: boolean;
}) => {
  return (
    <button
      data-testid={`plot-type-${plotType.value}`}
      onClick={() => setPlotType(plotType.value)}
      className={`w-full flex flex-col gap-1 border border-gray-200 rounded-md items-center justify-center py-1 hover:bg-[#ECFAFF]
            ${isSelected ? "plot-button-selected" : ""}
          `}
    >
      <span className="mt-1">{plotType.icon}</span>
      <div className="text-sm font-medium">{plotType.name}</div>
    </button>
  );
};
